var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_63",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0537 12L15.127 7.92701C15.2653 7.78851 15.3362 7.61443 15.3395 7.40476C15.3427 7.19526 15.2718 7.01801 15.127 6.87301C14.982 6.72818 14.8063 6.65576 14.6 6.65576C14.3937 6.65576 14.218 6.72818 14.073 6.87301L9.57874 11.3673C9.48524 11.4609 9.41924 11.5597 9.38074 11.6635C9.34224 11.7673 9.32299 11.8795 9.32299 12C9.32299 12.1205 9.34224 12.2327 9.38074 12.3365C9.41924 12.4403 9.48524 12.5391 9.57874 12.6328L14.073 17.127C14.2115 17.2653 14.3856 17.3362 14.5952 17.3395C14.8047 17.3427 14.982 17.2718 15.127 17.127C15.2718 16.982 15.3442 16.8063 15.3442 16.6C15.3442 16.3937 15.2718 16.218 15.127 16.073L11.0537 12Z",
    fill: "#1C1B1F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/Left_arrow.c70deb1f7433de4c522b81325ae565af.svg";
export { ForwardRef as ReactComponent };